var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 140,
    viewBox: "0 0 141 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.417 70.0002H63.85C61.4089 70.0081 59.221 68.4952 58.3667 66.2085L43.0833 25.3752C42.4056 23.5892 42.6453 21.5844 43.725 20.0085C44.8247 18.4231 46.6373 17.4841 48.5667 17.5002H108.417C122.914 17.5002 134.667 29.2527 134.667 43.7502C134.667 58.2477 122.914 70.0002 108.417 70.0002ZM85.025 75.8335H117.167L127.9 115.15C128.378 116.904 128.012 118.78 126.908 120.225C125.819 121.678 124.116 122.54 122.3 122.559H104.8C102.277 122.557 100.041 120.933 99.2583 118.534L85.025 75.8335ZM6.45 81.7252H12.2833V122.559H6.45V81.7252ZM64.6667 81.6669H58.8333V122.5H64.6667V81.6669ZM23.8333 81.6669H29.6667V116.667H23.8333V81.6669ZM47.1667 81.6669H41.3333V116.667H47.1667V81.6669Z",
    fill: "#7896B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanner);
export default __webpack_public_path__ + "static/media/scanner.968c6e353bb1e0b0fdb1b268f5bc2679.svg";
export { ForwardRef as ReactComponent };